import { CalendarDaysIcon, ClipboardCheckIcon, SunIcon, TrendingUpIcon, UsersIcon } from 'lucide-react';
import { NavTab } from '../types/ui';

export const childTabs: NavTab[] = [
  { id: 'danes', label: 'Danes', icon: SunIcon },
  { id: 'koledar', label: 'Koledar', icon: CalendarDaysIcon },
  { id: 'napredek', label: 'Napredek', icon: TrendingUpIcon },
  { id: 'druzina', label: 'Družina', icon: UsersIcon },
];

export const adminTabs: NavTab[] = [
  { id: 'pregled', label: 'Pregled', icon: ClipboardCheckIcon },
  { id: 'danes', label: 'Danes', icon: SunIcon },
  { id: 'koledar', label: 'Koledar', icon: CalendarDaysIcon },
  { id: 'druzina', label: 'Družina', icon: UsersIcon },
];
